import {useState} from 'react';

import {WorklistSummary} from 'worklists/WorklistConstants';

/**
 * Custom React hook to use a selected worklist id.
 */
export default function useSelectedWorklistId(): [
  string | null,
  (worklistSummary: WorklistSummary | null) => void,
] {
  const [selectedWorklistId, setSelectedWorklistId] = useState<string | null>(null);
  const updateWorklistId = (worklistSummary: WorklistSummary | null): void => {
    setSelectedWorklistId(worklistSummary ? worklistSummary.id : null);
  };
  return [selectedWorklistId, updateWorklistId];
}
